/**
 * Shifts: the header's shift menu, the stale-shift banner, opening, closing
 * and the Z-report on screen (the PRINTED Z-report is lib/print.ts and stays
 * Georgian), and money into or out of the drawer.
 */
export const shift = {
  'shift.title': 'ცვლა',
  'shift.open': 'ცვლის გახსნა',
  'shift.close': 'ცვლის დახურვა',
  'shift.closed': 'ცვლა დახურულია',
  'shift.closedAria': 'ცვლა დახურულია — გახსნა',
  'shift.openShort': 'ღია',
  'shift.openAria': 'ცვლა ღიაა — ცვლის მენიუ',
  'shift.menuTitle': 'ცვლა: სალაროს მოძრაობა და დახურვა',
  'shift.staleTitle': 'ცვლა {ago} გაიხსნა — დახურე და დაითვალე სალარო',
  'shift.staleAria': 'ცვლა {ago} გაიხსნა — ცვლის მენიუ',
  'shift.staleSub': 'გაიხსნა {ago} — დროა დახურო',
  'shift.days': '{n} დღე',
  'shift.openSince': 'ღიაა {time}-დან',
  'shift.cashOut': 'სალაროდან გატანა',
  'shift.cashOutSub': 'ხარჯი, მფლობელმა წაიღო, ბანკი',
  'shift.cashIn': 'სალაროში შეტანა',
  'shift.closeSub': 'დათვლა და Z-ანგარიში',
  // 1.41 — the shift card (the owner's „ა2")
  'shift.durHM': '{h} სთ {m} წთ',
  'shift.durM': '{m} წთ',
  'shift.sinceDur': 'ღიაა {time}-დან · {dur}',
  'shift.statReceipts': 'ჩეკები',
  'shift.statCash': 'სალაროში',
  'shift.statCard': 'ბარათით',
  'shift.tileOut': 'გატანა',
  'shift.tileIn': 'შეტანა',
  'shift.closeShort': 'დათვლა და Z',
  'shift.staleBanner': 'ეს ცვლა {ago} გაიხსნა',
  'shift.staleBody': 'დღევანდელი გაყიდვები ძველ ცვლაში ჩაიწერება. დახურე, დაითვალე სალარო და გახსენი ახალი.',

  'shift.enterPin': 'ჩაწერე მოლარის PIN',
  'shift.opened': 'ცვლა გახსნილია — {name}',
  'shift.needCashier': 'ცვლის გასახსნელად ჯერ დაამატეთ მოლარე',
  'shift.openHint': 'მოლარემ შეიყვანოს თავისი PIN და საწყისი თანხა კასაში',
  'shift.noCashiers': 'ჯერ არ გყავთ მოლარე',
  'shift.noCashiersBody': 'ცვლის PIN არის {cashier} PIN (და არა პარამეტრების სისტემური PIN). დაამატეთ მოლარე „თანამშრომლების" გვერდზე, მიანიჭეთ PIN და შემდეგ გახსენით ცვლა.',
  'shift.cashierGen': 'მოლარის',
  'shift.toStaff': 'თანამშრომლების გვერდზე',
  'shift.cashierPin': 'მოლარის PIN',
  'shift.openingCash': 'საწყისი თანხა კასაში ₾',
  'shift.carried': 'წინა ცვლამ კასაში დატოვა {sum}',
  'shift.gapLess': '{sum}-ით ნაკლებია, ვიდრე წინა ცვლამ დატოვა.',
  'shift.gapMore': '{sum}-ით მეტია, ვიდრე წინა ცვლამ დატოვა.',
  'shift.gapNote': 'სხვაობა ჩაიწერება და მფლობელი ნახავს.',
  'shift.wrongFloat': 'არასწორი ციფრი ცვლის დახურვისას იმავე ოდენობის სხვაობად გამოჩნდება.',
  'shift.emptyQ': 'კასა ცარიელია?',
  'shift.emptyBody': 'ხურდის გარეშე ₾10-იანს ვერ დაუბრუნებ. თუ მართლა ასეა, დააჭირე ხელახლა და ცვლა ₾0-ით გაიხსნება.',
  'shift.yesEmpty': 'დიახ, ცარიელია',

  'close.err.floatOver': 'კასაში დასატოვებელი თანხა დათვლილზე მეტი ვერ იქნება',
  'close.err.noteRequired': '„სხვა"-ს შენიშვნა სჭირდება — დაწერე, სად წავიდა თანხა',
  'close.err.pickBank': 'აირჩიე, რომელ ბანკში გააქვს',
  'close.done': 'ცვლა დაიხურა — Z-რეპორტი მზადაა',
  'close.zTitle': 'Z-რეპორტი',
  'close.openedAt': 'გახსნა {date}',
  'close.opening': 'საწყისი კასა',
  'close.openingGap': 'გახსნისას სხვაობა (წინა ცვლამ დატოვა {sum})',
  'close.cashSales': 'ნაღდი გაყიდვები',
  'close.creditSales': 'ნისიით (სულ)',
  'close.creditPaid': 'ნისიის გადახდილი (ნაღდი)',
  'close.returns': 'დაბრუნებები',
  'close.returnsCash': 'ნაღდით — კასიდან',
  'close.returnsCard': 'ბარათით — ბარათზე',
  'close.returnsCredit': 'ნისიით — ვალიდან',
  'close.returnsPrepaid': 'წინასწარი თანხით — ბალანსზე',
  'close.prepaidSales': 'წინასწარი თანხიდან',
  'close.prepaidInCash': 'წინასწარ მიღებული — ნაღდი',
  'close.prepaidOutCash': 'წინასწარ დაბრუნებული — ნაღდი',
  'close.prepaidCard': 'ბარათით: მიღებული {in} · დაბრუნებული {out} — ბრუნვაში არ შედის',
  'close.terminalDay': 'ტერმინალის დღის ჯამი {sum} = {card} გაყიდვები − {back} დაბრუნება + {pp} წინასწარი − {out} დაბრუნებული წინასწარი',
  'close.returnsExchange': 'გაცვლით — ნივთი ნივთზე',
  'close.chain.opening': 'საწყისი',
  'close.chain.cashSales': 'ნაღდი გაყიდვა',
  'close.chain.creditPaid': 'ნისიის ნაღდი',
  'close.chain.debtPayments': 'ვალის გადახდა',
  'close.chain.cashRefunds': 'დაბრუნება ნაღდით',
  'close.chain.exchangeCash': 'გაცვლით დაბრუნებული',
  'close.chain.supplierCash': 'მომწოდებელს',
  'close.chain.drawerIn': 'შეტანა',
  'close.chain.drawerOut': 'გატანა',
  'close.chain.keptIn': 'ხურდიდან დარჩა',
  'close.chain.keptOut': 'ხურდას დავამატეთ',
  'close.chain.prepaidIn': 'წინასწარ მიღებული',
  'close.chain.prepaidOut': 'წინასწარ დაბრუნებული',
  'close.changeKept': 'ხურდის თეთრები',
  'close.changeKeptSplit': 'დარჩა {kept} · დავამატეთ {given}',
  'close.salesTotal': 'გაყიდვების ჯამი',
  'close.salesCount': 'გაყიდვების რაოდენობა',
  'close.debtPayments': 'ვალის გადახდები (ნაღდი)',
  'close.supplierPayments': 'მომწოდებლის გადახდა (ნაღდი)',
  'close.drawerIn': 'შეტანა სალაროში',
  'close.drawerOut': 'გატანა სალაროდან',
  'close.expected': 'მოსალოდნელი კასა',
  'close.countedLabel': 'დათვლილი კასა ₾',
  'close.counted': 'დათვლილი კასა',
  'close.diff': 'სხვაობა',
  'close.over': 'კასაში მეტი ფულია ვიდრე მოსალოდნელი (ზედმეტობა).',
  'close.short': 'კასაში ნაკლები ფულია (დანაკლისი).',
  'close.leftForNext': 'კასაში დარჩა შემდეგი ცვლისთვის',
  'close.taken': 'გატანილი — {where}',
  'close.floatLabel': 'კასაში რჩება შემდეგი ცვლისთვის ₾',
  'close.floatSetting': 'პარამეტრებში {sum}',
  'close.takingOut': 'გაგაქვს კასიდან',
  'close.whereAria': 'სად მიდის თანხა',
  'close.notePh': 'სად წავიდა? მაგ. გადაეცა ბუღალტერს',
  'close.remind': 'პარამეტრებში კასაში {sum} უნდა დარჩეს ხურდისთვის.',
  'close.remindConfirm': 'თუ მაინც ასე გინდა, დააჭირე „დიახ, დახურვა".',
  'close.remindLeft': 'რჩება {sum}.',
  'close.offlinePending': '📴 {n} გაყიდვა ჯერ არ არის ატვირთული — დაელოდე ინტერნეტს, მერე დახურე ცვლა.',
  'close.yesClose': 'დიახ, დახურვა',
  'close.gapTitle': 'გადაამოწმე დათვლილი თანხა',
  'close.gapOver': 'დათვლილი მოსალოდნელზე {sum}-ით მეტია. სწორად ჩაწერე?',
  'close.gapUnder': 'დათვლილი მოსალოდნელზე {sum}-ით ნაკლებია. სწორად ჩაწერე?',
  'close.gapFix': 'შევასწორებ',
  'close.gapYes': 'კი, სწორია',
  'close.finish': 'დასრულება',
  'close.salaryLabel': 'მოლარის ხელფასი · {name} ₾',
  'close.salaryPaid': 'დღეს ამ მოლარეზე უკვე გაცემულია {sum}',
  'close.salaryOver': 'დღის ლიმიტი {sum} — მეტს მფლობელის PIN სჭირდება',
  'close.salary': 'ხელფასი — {name}',
  'close.err.salaryOver': 'ხელფასი დათვლილზე მეტი ვერ იქნება',
  'close.err.salaryInvalid': 'ხელფასის თანხა არასწორია — თეთრამდე და არა დათვლილზე მეტი',
  'close.err.salaryLimit': 'დღეს ამ მოლარისთვის ხელფასი მაქსიმუმ {sum} — მეტს მფლობელის PIN სჭირდება',
  'close.err.pinWrong': 'მფლობელის PIN არასწორია — ცვლა არ დაიხურა',
  'close.pinTitle': 'მფლობელის PIN',
  'close.pinBody': 'ხელფასი {sum} აჭარბებს ამ ცვლის ლიმიტს ({limit}). გასაგრძელებლად მფლობელმა უნდა ჩაწეროს სისტემის PIN.',

  'bank.which': 'რომელ ბანკში',

  'drawer.cat.salary': 'ხელფასი',
  'drawer.cat.transport': 'ტრანსპორტი / კურიერი',
  'drawer.cat.utilities': 'კომუნალური',
  'drawer.cat.other': 'სხვა ხარჯი',
  'drawer.savedOut': 'გატანა ჩაიწერა — {sum}',
  'drawer.savedIn': 'შეტანა ჩაიწერა — {sum}',
  'drawer.deleted': 'ჩანაწერი წაიშალა',
  'drawer.desc': '{name} · ცვლა {time}-დან — ჩანაწერი ცვლის დახურვასა და Z-ანგარიშში გამოჩნდება',
  'drawer.direction': 'მიმართულება',
  'drawer.out': 'გატანა',
  'drawer.in': 'შეტანა',
  'drawer.amount': 'თანხა ₾',
  'drawer.amountHint': '0-ზე მეტი, მაქსიმუმ ₾100 000, თეთრი — ორი ციფრით',
  'drawer.reason': 'მიზეზი',
  'drawer.expenseKind': 'ხარჯის სახე',
  'drawer.expenseNote': 'ბუღალტერიის „ხარჯებშიც" ჩაიწერება — მოგებაში ერთხელ აისახება, ხელახლა შეყვანა არ სჭირდება.',
  'drawer.notePhRequired': 'რისთვის? (აუცილებელია)',
  'drawer.notePhOut': 'შენიშვნა — მაგ. კურიერი',
  'drawer.notePhIn': 'შენიშვნა — მაგ. ხურდა ბანკიდან',
  'drawer.thisShift': 'ამ ცვლაში',
  'drawer.keep': 'არ წაიშალოს',
  'drawer.deleteAria': 'ჩანაწერის წაშლა',
  'drawer.deleteTitle': 'წაშლა — ხარჯად ჩაწერილიც წაიშლება',
  // 1.36
  'close.exchanges': 'მათ შორის გაცვლა: {n} · დამატებით {sum}',
} as const
